<table class="table  table-bordered  table-sm  mb-0">
    <tr>
        <td>Ordrenummer:</td>
        <td><strong>{{order.getIdentificationReference()}}</strong></td>
    </tr>
    <tr *ngIf="order.linked_order">
        <td>
            <span *ngIf="order.linked_order.isCreditor()">Salgsordre:</span>
            <span *ngIf="order.linked_order.isDebtor()">Købsordre:</span>
        </td>
        <td>
            <a routerLink="/orders/{{ order.linked_order_id }}">{{ order.linked_order.getIdentificationReference() }}</a>
        </td>
    </tr>
    <tr>
        <td>Ordredato:</td>
        <td><strong>{{ order.getDate('is_creation') ? order.getDate('is_creation')._joinData.time.format('YYYY-MM-DD') : '-' }}</strong></td>
    </tr>
    <tr>
        <td>Leveringsdato:</td>
        <td><strong>{{ order.getDate('is_shipping') ? order.getDate('is_shipping')._joinData.time.format('YYYY-MM-DD') : '-' }}</strong></td>
    </tr>
    <tr>
        <td>Forfaldsdato:</td>
        <td><strong>{{ order.getDate('is_due') ? order.getDate('is_due')._joinData.time.format('YYYY-MM-DD') : '-' }}</strong></td>
    </tr>
    <tr>
        <td>Rekvisionsnummer:</td>
        <td><strong>{{ order.getFieldValueForId(ORDER_FIELDS_IDS.REQUISITION_NUMBER) ? order.getFieldValueForId(ORDER_FIELDS_IDS.REQUISITION_NUMBER) : '-' }}</strong></td>
    </tr>
    <tr>
        <td>EAN:</td>
        <td><strong>{{ order.getFieldValueForId(ORDER_FIELDS_IDS.EAN) ? order.getFieldValueForId(ORDER_FIELDS_IDS.EAN) : '-' }}</strong></td>
    </tr>
    <tr>
        <td>Betaling via bon</td>
        <td class="bg-danger"><!-- @todo --></td>
    </tr>
    <tr>
        <td>Saldo</td>
        <td>
            <span *ngIf="!creditor && !debtor" class="text-muted">Indlæser...</span>
            <strong *ngIf="order.isCreditor() && creditor">{{ creditor.balance | currency:'DKK':'':null }}</strong>
            <strong *ngIf="!order.isCreditor() && debtor">{{ debtor.balance | currency:'DKK':'':null }}</strong>
        </td>
    </tr>
</table>
